import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { CPS_CONTENT_TYPE_FIELD_TYPE } from '@cs-cms/types';
import { FormDatePicker } from '../../fields/FormDatePicker';
import { getRequiredValidator, isFieldOptional } from '../fieldMapperHelpers';
import { FieldMapperContext } from '../fieldMapperTypes';

export function renderDateField(ctx: FieldMapperContext): React.ReactElement {
  const { ctField, fieldLabel, fieldDisabled, handleChange } = ctx;

  return (
    <Field
      key={ctField.name}
      name={ctField.name}
      component={FormDatePicker}
      label={fieldLabel}
      validator={getRequiredValidator(ctField)}
      optional={isFieldOptional(ctField)}
      includeTime={ctField.type === CPS_CONTENT_TYPE_FIELD_TYPE.DATETIME}
      hint={ctField.hint}
      onChange={handleChange}
      disabled={fieldDisabled}
    />
  );
}
